function prevProductMedia (btn) {
  let activeMedia = btn.parentElement.querySelector('.product__thumbnails .active[data-product-single-thumbnail]');
  let activeIndex = activeMedia.dataset.productImageIndex;
  
  if(activeMedia.hasAttribute('first-thumbnail')) return;
  
  let prevMedia = btn.parentElement.querySelector(`.product__thumbnails [data-product-image-index="${--activeIndex}"]`);
  prevMedia.click();
}

function nextProductMedia (btn) {
  let activeMedia = btn.parentElement.querySelector('.product__thumbnails .active[data-product-single-thumbnail]');
  let activeIndex = activeMedia.dataset.productImageIndex;
  
  if(activeMedia.hasAttribute('last-thumbnail')) return;
  
  let nextMedia = btn.parentElement.querySelector(`.product__thumbnails [data-product-image-index="${++activeIndex}"]`);
  nextMedia.click();
}

function productThumbClicked(thumb) {
  let prevBtn = thumb.closest('.product__thumbnails').querySelector('#productThumbPrev');
  let nextBtn = thumb.closest('.product__thumbnails').querySelector('#productThumbNext');
  
  thumb.hasAttribute('first-thumbnail') ? prevBtn.setAttribute('disabled', '') : prevBtn.removeAttribute('disabled')
  thumb.hasAttribute('last-thumbnail') ? nextBtn.setAttribute('disabled', '') : nextBtn.removeAttribute('disabled')
}